import React from "react";
import "./index.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Nav from "./components/Nav";
import TrackPage from "./pages/TrackPage";
import ReportsPage from "./pages/ReportsPage";
import ManagePage from "./pages/ManagePage";
import ImportPage from "./pages/ImportPage";
import ExportPage from "./pages/ExportPage";
import TermsPage from "./pages/TermsPage";
import { Toaster } from "./components/ui/toaster";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AuthPage from "./pages/AuthPage";
import AdminPage from "./pages/AdminPage";
import HubPage from "./pages/HubPage";
import CalendarPage from "./pages/CalendarPage";
import AccountPage from "./pages/AccountPage";

function Placeholder({ title }) {
  return (
    <div className="mx-auto max-w-6xl px-4 py-10">
      <h1 className="text-2xl font-semibold">{title}</h1>
      <p className="text-muted-foreground mt-2">This section is a preview.</p>
    </div>
  );
}

function RequireAuth({ children }){
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="p-8 text-sm text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/auth" state={{ from: location }} replace />;
  return children;
}

export default function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/legal/terms" element={<Layout><TermsPage /></Layout>} />
            <Route path="/" element={<RequireAuth><Layout><HubPage /></Layout></RequireAuth>} />
            <Route path="/hub" element={<RequireAuth><Layout><HubPage /></Layout></RequireAuth>} />
            <Route path="/calendar" element={<RequireAuth><Layout><CalendarPage /></Layout></RequireAuth>} />
            <Route path="/track" element={<RequireAuth><Layout><TrackPage /></Layout></RequireAuth>} />
            <Route path="/reports" element={<RequireAuth><Layout><ReportsPage /></Layout></RequireAuth>} />
            <Route path="/export" element={<RequireAuth><Layout><ExportPage /></Layout></RequireAuth>} />
            <Route path="/entries" element={<RequireAuth><Layout><Placeholder title="All Entries" /></Layout></RequireAuth>} />
            <Route path="/manage" element={<RequireAuth><Layout><ManagePage /></Layout></RequireAuth>} />
            <Route path="/import" element={<RequireAuth><Layout><ImportPage /></Layout></RequireAuth>} />
            <Route path="/admin" element={<RequireAuth><Layout><AdminPage /></Layout></RequireAuth>} />
            <Route path="/account" element={<RequireAuth><Layout><AccountPage /></Layout></RequireAuth>} />
          </Routes>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

function Layout({ children }){
  return (
    <>
      <Nav />
      {children}
    </>
  );
}